module.exports = __webpack_public_path__ + "img/_DSC1160.8b4120d2.jpg";